import { render } from "./AverageStats.vue?vue&type=template&id=6a0607c8"
import script from "./AverageStats.vue?vue&type=script&lang=js"
export * from "./AverageStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Charts/AverageStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a0607c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a0607c8', __exports__)) {
    api.reload('6a0607c8', __exports__)
  }
  
  module.hot.accept("./AverageStats.vue?vue&type=template&id=6a0607c8", () => {
    api.rerender('6a0607c8', render)
  })

}


export default __exports__